import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as sharedActions, selectors as sharedSelectors } from "@shared/store";
import { AlertForm } from "@containers/Alert/components";
import { actions } from "@containers/Alert/store";
import { CreateAlertDto } from "@containers/Alert/interfaces";
import { Alert } from "@shared/models";

interface AlertCreateEditContainerProps {
  userId: number | null;
  hospitalId: number;
  alertList: Alert[];
  onClose: () => void;
}

const AlertCreateEditContainer = (props: AlertCreateEditContainerProps) => {
  const dispatch = useDispatch();
  const { onClose, userId, alertList, hospitalId } = props;

  const authorizedUser = useSelector(sharedSelectors.getUserDetails());

  const changeFormValues = useCallback(() => {
    dispatch(sharedActions.updateOverlay({ leaveConfirm: true }));
  }, [dispatch]);

  const submitForm = useCallback(
    (payload: CreateAlertDto["alert_settings"]) => {
      dispatch(sharedActions.hideOverlay());
      userId
        ? dispatch(actions.createUserAlert.request({ hospital_id: hospitalId, id: userId, alert_settings: payload }))
        : dispatch(actions.createAlert.request({ hospital_id: hospitalId, alert_settings: payload }));
    },
    [dispatch, hospitalId, userId],
  );

  useEffect(() => {
    dispatch(actions.getAlerts.request({ hospital_id: hospitalId, user_id: userId || undefined }));
  }, [dispatch, hospitalId, userId]);

  return (
    <div className="alert-create-edit-container">
      <AlertForm
        userId={userId}
        onChangeForm={changeFormValues}
        onCloseForm={onClose}
        onSubmitForm={submitForm}
        authorizedUser={authorizedUser}
        alertList={alertList}
      />
    </div>
  );
};

export default AlertCreateEditContainer;
